const COOKIE_CONTROL = "cookieControl";
const COOKIE_CONTROL_PREFERENCES = "cookieControlPreferences";

function getCookie(name) {
  const cookie_name = name + "=";
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(";");

  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(cookie_name) === 0) {
      return c.substring(cookie_name.length, c.length);
    }
  }
  return false;
}

function setCookie(name, value, expiry_days) {
  const d = new Date();
  d.setTime(d.getTime() + expiry_days * 24 * 60 * 60 * 1000);
  const expires = "expires=" + d.toUTCString();
  document.cookie = name + "=" + value + ";" + expires + ";Secure;path=/";
  return getCookie(name);
}

function dropCookie(value, expiryDays) {
  setCookie(COOKIE_CONTROL, value, expiryDays);
}

function areCookiesSelected() {
  return Boolean(
    getCookie(COOKIE_CONTROL) && getCookie(COOKIE_CONTROL_PREFERENCES)
  );
}

function cookiePreference(cookieTypeValue) {
  const control = getCookie(COOKIE_CONTROL);
  let preferences = getCookie(COOKIE_CONTROL_PREFERENCES);

  try {
    preferences = JSON.parse(preferences);
  } catch (e) {
    return false;
  }

  if (!control || !preferences) {
    return false;
  }

  return preferences?.[cookieTypeValue] === 1;
}

function isDoNotTrackEnabled() {
  if (typeof window === "undefined") return false;

  const doNotTrack =
    window.doNotTrack ||
    navigator.doNotTrack ||
    navigator.msDoNotTrack ||
    msTracking();

  if (!doNotTrack) return false;

  if (
    doNotTrack === "1" ||
    doNotTrack === "yes" ||
    doNotTrack === 1 ||
    (typeof doNotTrack === "string" && doNotTrack.charAt(0) === "1")
  ) {
    return true;
  }

  return false;
}

function msTracking() {
  return (
    "msTrackingProtectionEnabled" in window.external &&
    typeof window.external.msTrackingProtectionEnabled === "function" &&
    window.external.msTrackingProtectionEnabled()
  );
}

export {
  getCookie,
  setCookie,
  dropCookie,
  areCookiesSelected,
  cookiePreference,
  isDoNotTrackEnabled,
  COOKIE_CONTROL,
  COOKIE_CONTROL_PREFERENCES
};
